module.exports = __webpack_public_path__ + "static/media/pre_registration.f009378b.svg";